import { useEffect } from 'react';
import axios from 'axios';
import { getAccessTokenFromRedux, getRefreshTokenFromRedux } from './authService';
import { dispatch } from "../../store";
import { LOGIN } from "store/reducers/auth";
import dayjs from 'dayjs';

const IDLE_TIMEOUT = process.env.REACT_APP_IDLE_TIMEOUT;
const REFRESH_INTERVAL = process.env.REACT_APP_REFRESH_INTERVAL;

function isTokenExpired(token) {
    // console.log(token)
  if (!token) return true;
  try {
    const payload = JSON.parse(
      decodeURIComponent(
        atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))
          .split('')
          .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      )
    );
    // console.log(payload)
    const now = Math.floor(Date.now() / 1000);
    // console.log((payload.exp - now) / 60)
    return payload.exp < now;
  } catch {
    return true;
  }
}

export function useTokenRefresh () {

    useEffect(() => {
        let lastActivity = Date.now();

        const updateActivity = () => {
            lastActivity = Date.now();
            // console.log(lastActivity)
            // console.log('start : ', dayjs(lastActivity).format("YYYY-MM-DD HH:mm:ss"));
        };

        const refreshIfExpired = async () => {
            // console.log(111111)
            // console.log("lastActivity : "+dayjs(lastActivity).format("YYYY-MM-DD HH:mm:ss"));
            const now = Date.now();
            // console.log('now - lastActivity : ', now - lastActivity)
            if (now - lastActivity > IDLE_TIMEOUT) return;
            // console.log('now : ', dayjs(now).format("YYYY-MM-DD HH:mm:ss"));
            const accessToken = getAccessTokenFromRedux();
            const refreshToken = getRefreshTokenFromRedux();

            if (!refreshToken) {
                window.location.href = '/auth/logoutProcess';
                return;
            }

            if (isTokenExpired(accessToken)) {
                // console.log('============== refresh ==============')
                try {
                    const res = await axios.post(process.env.REACT_APP_API_URL+'/api/public/login/refresh', { refresh_token:refreshToken });
                    if (res.data.id_token) {
                        dispatch(LOGIN({accessToken:res.data.id_token, refreshToken:res.data.refresh_token}));
                        updateActivity();
                    }
                } catch (err) {
                    console.log(err)
                    window.location.href = '/auth/logoutProcess';
                }
            }
        };

        const intervalId = setInterval(refreshIfExpired, REFRESH_INTERVAL);

        window.addEventListener('mousedown', updateActivity);
        window.addEventListener('keydown', updateActivity);

        return () => {
            clearInterval(intervalId);
            window.removeEventListener('mousedown', updateActivity);
            window.removeEventListener('keydown', updateActivity);
        };
    }, []);
};
